export const StudentFlashcardCollectionTranslations = {
  TEST: {
    es: 'Tests',
    en: 'Tests',
    cat: 'Tests',
    eus: 'Tests',
    pt: 'Testes'
  },
  COLLECTIONS: {
    es: 'Colecciones',
    en: 'Collections',
    cat: 'Col·leccions',
    eus: 'Kollekzioak',
    pt: 'Coleções'
  },
  CREATE_COLLECTION: {
    es: 'Crear colección',
    en: 'Create collection',
    cat: 'Crear col·lecció',
    eus: 'Kollekzioa sortu',
    pt: 'Criar coleção'
  },
  CREATE_COLLECTION_TITLE: {
    es: 'Nueva colección de flashcards',
    en: 'New flashcards collection',
    cat: 'Nova col·lecció de flashcards',
    eus: 'Flashcards kollekzio berria',
    pt: 'Nova coleção de flashcards'
  },
  UPDATE_COLLECTION_TITLE: {
    es: 'Editar colección de flashcards',
    en: 'Edit flashcards collection',
    cat: 'Editar col·lecció de flashcards',
    eus: 'Editatu flashcards kollekzioa',
    pt: 'Editar coleção de flashcards'
  },
  CREATE: {
    es: 'Crear',
    en: 'Create',
    cat: 'Crear',
    eus: 'Sortu',
    pt: 'Criar'
  },
  UPDATE: {
    es: 'Actualizar',
    en: 'Update',
    cat: 'Actualitzar',
    eus: 'Eguneratu',
    pt: 'Atualizar'
  },
  COURSE: {
    es: 'Curso',
    en: 'Course',
    cat: 'Curs',
    eus: 'Kursua',
    pt: 'Curso'
  },
  COLLECTION_NAME: {
    es: 'Nombre de la colección',
    en: 'Collection name',
    cat: 'Nom de la col·lecció',
    eus: 'Kollekzioaren izena',
    pt: 'Nome da coleção'
  },
  SECTIONS: {
    es: 'Temas (opcional)',
    en: 'Sections (optional)',
    cat: 'Temes (opcional)',
    eus: 'Gaiak (aukerakoa)',
    pt: 'Temas (opcional)'
  },
  SHARE_COLLECTION_WITH_UCADEMY_COMUNITY: {
    es: 'Próximamente, podrás compartir tus colecciones de flashcards con la comunidad de Ucademy.',
    en: "Coming soon, you'll be able to share your flashcard collections with the Ucademy community.",
    cat: 'Properament, podràs compartir les teves col·leccions de flashcards amb la comunitat d’Ucademy.',
    eus: 'Laster, zure flashcard bildumak Ucademy komunitatearekin partekatu ahal izango dituzu.',
    pt: 'Em breve, você poderá compartilhar suas coleções de flashcards com a comunidade da Ucademy.'
  }
};
